import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { ManagerEffects } from './manager.effects';
import { reducer } from './manager.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('manager', reducer),
    EffectsModule.forFeature([ManagerEffects]),
  ],
  providers: [ManagerEffects],
})
export class ManagerStoreModule {}
